import * as React from 'react';
import { Modal } from '@app/src/components/Modal';
import {
  FrameWrapper,
  Title,
  Text
} from './styled';

export const Container = ({
  openModal,
  closeModal,
  item,
  message
}) => {
  const handleCloseModal = () => {
    closeModal();
  };

  return (
    <>
    {!message &&
      <Modal
        openModal={openModal}
        closeModal={handleCloseModal}
      >
          <FrameWrapper>
            <Title>Celular:</Title>
            <Text>{item.phone}</Text>
            <Title>E-mail:</Title>
            <Text>{item.email}</Text>
            <Title>Nro Pedido:</Title>
            <Text>{item.requestNumber}</Text>
            <Title>Detalle</Title>
            <Text>{item.extra}</Text>
          </FrameWrapper>
      </Modal>
    }
    </>
  )
}
